<template>
  <md-table-cell class="tx-history__cell">
    <md-button
      ref="copyBtn"
      :data-clipboard-text="value"
      @click="showCopySuccess"
    >
      {{ valueToShow }}
      <md-tooltip md-direction="top">{{ i18n.lbl_copy() }}</md-tooltip>
    </md-button>
  </md-table-cell>
</template>

<script>
/* eslint-disable */
import Clipboard from 'clipboard'
import { EventDispatcher } from '@js/events/event_dispatcher'
import { i18n } from '@js/i18n'

export default {
  data: () => ({
    clipboard: null,
    i18n
  }),
  props: {
    value: { type: [String, Number], default: '' },
    valueToShow: { type: [String, Number], default: '' },
  },
  mounted() {
    this.$nextTick(() => {
      const button = this.$refs.copyBtn.$el
      if (button) {
        this.clipboard = new Clipboard(button)
      } else {
        console.warn('Clipboard target not found:', `clipboardBtn-${this.value}`)
      }
    })
  },
  methods: {
    showCopySuccess() {
      EventDispatcher.dispatchShowSuccessEvent(i18n.dep_copied())
    },
  },
}
</script>

<style scoped lang="scss">
.dnone {
  display: none;
}
/deep/  .md-button {
  min-width: 0;
  width: auto;
  height: auto;
  margin: 0;
}

/deep/ .md-ripple {
  padding: 0;
}
/deep/ .md-table-cell-container {
  display: flex;
}

</style>


// WEBPACK FOOTER //
// src/vue/app/refundHistory/CopyVal.vue